import { ModalProps } from '@mui/material'
import { useRef } from 'react'
import Container from '../../components/atoms/Container'
import Heading from '../../components/atoms/Heading'
import Input from '../../components/atoms/Input'
import DateInput from '../../components/atoms/DateInput'
import Button from '../../components/molecules/Button'
import { StyledDialog, StyledDialogContent } from './styled'

type EditInvoiceDetailsProps = {
  open: boolean
  onClose: ModalProps['onClose']
  onSubmit: (data: { invoiceNumber: string; paymentDate: string }) => void
}

const EditInvoiceDetails = (props: EditInvoiceDetailsProps) => {
  const invoiceNumberRef = useRef<HTMLInputElement>(null)
  const paymentDateRef = useRef<HTMLInputElement>(null)

  const handleSubmit = () => {
    const invoiceNumber = invoiceNumberRef.current?.value
    const paymentDate = paymentDateRef.current?.value
    if (invoiceNumber && paymentDate) {
      props.onSubmit({ invoiceNumber, paymentDate })
      if (props.onClose) props.onClose({}, 'backdropClick')
    }
  }

  return (
    <StyledDialog open={props.open} onClose={props.onClose}>
      <StyledDialogContent>
        <Heading type="4" border>
          Datos de Factura
        </Heading>
        <Container>
          <Input
            ref={invoiceNumberRef}
            label="Número de Factura"
          />
          <DateInput
            ref={paymentDateRef}
            label="Fecha de Pago"
          />
          <Button onClick={handleSubmit}>Guardar</Button>
        </Container>
      </StyledDialogContent>
    </StyledDialog>
  )
}

export default EditInvoiceDetails
